import { render, staticRenderFns } from "./GestioneModuli.vue?vue&type=template&id=7dc7475a&scoped=true&"
import script from "./GestioneModuli.vue?vue&type=script&lang=js&"
export * from "./GestioneModuli.vue?vue&type=script&lang=js&"
import style0 from "./GestioneModuli.vue?vue&type=style&index=0&id=7dc7475a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc7475a",
  null
  
)

export default component.exports